import { useState } from "react";
import { toast } from "sonner";
import { Download, FileText, Loader2 } from "lucide-react";
import { downloadArt, fileSize, formatError } from "@/lib/api";

export function ArtFileList({ files }) {
  const [loading, setLoading] = useState(null);

  const get = async (f) => {
    setLoading(f.id);
    try {
      await downloadArt(f);
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setLoading(null);
    }
  };

  if (!files?.length) return <p className="text-sm text-slate-400">Nenhum arquivo enviado.</p>;
  return (
    <ul className="space-y-2">
      {files.map((f) => (
        <li key={f.id} className="flex items-center gap-3 rounded-md border border-slate-200 bg-white px-3 py-2">
          <FileText className="h-4 w-4 text-[#E5007D]" />
          <span className="flex-1 truncate text-sm font-semibold">{f.name}</span>
          <span className="text-xs text-slate-500">{fileSize(f.size)}</span>
          <button onClick={() => get(f)} disabled={loading === f.id} data-testid={`btn-download-art-${f.id}`}
            className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 px-3 py-1.5 text-xs font-bold text-white transition-colors hover:bg-[#0099DD] disabled:opacity-60">
            {loading === f.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />} Baixar
          </button>
        </li>
      ))}
    </ul>
  );
}
